import React, { useEffect, useState } from "react";
import ReactECharts from "echarts-for-react";
const token = localStorage.getItem("authToken");

const StockGraphs = () => {
  const [chartData, setChartData] = useState(null);

useEffect(() => {
  const fetchAndProcess = async () => {
    const groupId = localStorage.getItem("userId");
    const members = JSON.parse(localStorage.getItem("members") || "[]");
    if (!groupId || members.length === 0) return;

    try {
      const res = await fetch(`https://api.pharmacegroup.co.uk/getInventory?groupId=${groupId}`);
      const data = await res.json();

      const now = new Date();

      // Create a mapping from pharmacyId => pharmacyName
      const pharmacyMap = {};
      members.forEach(m => {
        pharmacyMap[m.pharmacyId] = m.pharmacyName;
      });

      // Initialize shelf and expiry data for each pharmacyName
      const shelfData = {};
      const expiryData = {};
      Object.values(pharmacyMap).forEach(name => {
        shelfData[name] = Array(53).fill(0);
        expiryData[name] = Array(53).fill(0);
      });

      // Process inventory data
      for (const item of data) {
        if (item.status !== "On shelf") continue;

        const phId = item.pharmacyId;
        const phName = pharmacyMap[phId]; // use name as key for labels
        if (!phName) continue;

        const price = item.price || 0;
        const qty = parseInt(item.balance || 0);
        const value = (qty * price) / 100;

        const fs = item.firstScanned ? new Date(item.firstScanned) : null;
        const ed = item.expiryDate ? new Date(item.expiryDate) : null;

        const shelfWeeks = fs ? Math.min(52, Math.floor((now - fs) / (1000 * 60 * 60 * 24 * 7))) : 0;
        const expiryWeeks = ed ? Math.max(0, Math.min(52, Math.floor((ed - now) / (1000 * 60 * 60 * 24 * 7)))) : 52;

        shelfData[phName][shelfWeeks] += value;
        expiryData[phName][expiryWeeks] += value;
      }

      // Use pharmacy names as labels
      setChartData({ shelfData, expiryData, pharmacies: Object.values(pharmacyMap) });
    } catch (err) {
      console.error("Error fetching inventory:", err);
    }
  };

  fetchAndProcess();
}, []);
  if (!chartData) return <div>Loading graphs...</div>;

  const buildSeries = (dataMap) =>
    chartData.pharmacies.map(ph => ({
      name: ph,
      type: 'line',
      data: dataMap[ph]
    }));

  const shelfOption = {
    title: { text: 'Stock value by time on shelves' },
    tooltip: { trigger: 'axis' },
    xAxis: {
      type: 'category',
      name: 'Weeks on shelves',
      data: Array.from({ length: 53 }, (_, i) => i === 52 ? '>52' : `${i}`)
    },
    yAxis: { type: 'value', name: 'Value (£)' },
    legend: { data: chartData.pharmacies },
    series: buildSeries(chartData.shelfData)
  };

  const expiryOption = {
    title: { text: 'Stock value by weeks to expiry' },
    tooltip: { trigger: 'axis' },
    xAxis: {
      type: 'category',
      name: 'Weeks to expiry',
      data: Array.from({ length: 53 }, (_, i) => i === 52 ? '>52' : `${52 - i}`)
    },
    yAxis: { type: 'value', name: 'Value (£)' },
    legend: { data: chartData.pharmacies },
    series: buildSeries(chartData.expiryData)
  };

  return (
    <div style={{ padding: '20px' }}>
      <ReactECharts option={shelfOption} style={{ height: "400px", marginBottom: "40px" }} />
      <ReactECharts option={expiryOption} style={{ height: "400px" }} />
    </div>
  );
};

export default StockGraphs;
